<template>
  <v-list-item
    v-bind="$props"
    :disabled="disabled"
    :class="hide ? 'w-list-item--hidden' : 'w-list-item'"
    v-on="$listeners"
  >
    <div style="display: flex; width: 100%;">
      <div
        style="display: flex;"
        @click="$emit('rowClicked')"
      >
        <slot name="item-prepend" />
        <v-list-item-action v-if="hasActionSlot">
          <slot name="list-action" />
        </v-list-item-action>
        <v-list-item-icon v-if="icon">
          <w-icon :disabled="disabled">
            {{ icon }}
          </w-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :class="disabled ? 'w-list-item--disabled' : ''">
            <i> {{ iconLabel }}</i>
            {{ label }}
          </v-list-item-title>
        </v-list-item-content>
      </div>
      <div style="margin-left: 1rem;">
        <slot name="item-append" />
      </div>
    </div>
  </v-list-item>
</template>

<script>
import { VListItem } from 'vuetify/lib';

export default {
  model: {
    event: 'change'
  },
  props: {
    disabled: { type: Boolean, default: false },
    hide: { type: Boolean, default: false },
    icon: { type: String },
    iconLabel: { type: String },
    label: { type: String },
    ...VListItem.options.props
  },
  computed: {
    hasActionSlot() {
      return this.$slots['list-action'];
    }
  }
};
</script>

<style lang="scss" scoped>
.w-list-item {
  &--hidden {
    display: none;
  }
  &:hover .v-list-item__icon,
  &:hover .v-list-item__title {
    color: var(--v-accent-base);
  }

  .v-list-item {
    &--active::before {
      opacity: 0 !important;
    }
    &__icon {
      margin-right: 1rem;
      display: flex;
      align-self: center;
      align-items: center;
      .svg { 
        color: $input-label-color;
      }
    }

    &__title {
      @include w-p2;
      color: $input-label-color;
      &.w-list-item--disabled {
        opacity: $disabled-opacity !important;
      }
    }
  }
}
</style>
